import React, { useState } from "react";
import { LottoIcon } from "../../../../utils/api-manager/Forms/SvgIcons";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import { useToastHandler } from '../../../common/ToastHandler';
import { Toast , ToastContainer } from "react-bootstrap";
import { parseLotteryScanCode } from "../../../../utils/lotteryScanParser";
const LotteryScanModal = ({ 
  show, 
  onClose, 
  shiftDetails, 
  onScanSuccess,
  scannedTickets = [],
  shiftId,
}) => {
  const { Post } = useApi();
  const { handleToast } = useToastHandler();

  const [scanNumber, setScanNumber] = useState("");
  const [gameTicketScanNo, setGameTicketScanNo] = useState("");
  const [bookTicketScanNo, setBookTicketScanNo] = useState("");
  const [ticketScanNo, setTicketScanNo] = useState("");
  const [lastTicketNo, setLastTicketNo] = useState(0);

  const getTicketWithGameAndBook = (input) => {
    const parsed = parseLotteryScanCode(input);
    return {
      gameNo: parsed.gameNo,
      bookNo: parsed.bookNo,
      ticketNo: parsed.ticketNo || parsed.ticketCandidate,
    };
  };

  const getTodayTicketNo = (dataArray, gameNumber) => {
    const game = dataArray.find((item) => item.game_no === gameNumber);
    return game ? game.today_ticket_no : 0;
  };

  const getCurrentShiftId = () => {
    if (shiftId) return shiftId;
    if (shiftDetails?.shift?.id) return shiftDetails.shift.id;
    if (shiftDetails?.shift?.shift_id) return shiftDetails.shift.shift_id;
    if (shiftDetails?.shift_id) return shiftDetails.shift_id;
    if (shiftDetails?.id) return shiftDetails.id;
    return null;
  };

  const handleScanNumberChange = (e) => {
    const newScanNumber = e.target.value;
    if (/^\d{0,50}$/.test(newScanNumber)) {
      setScanNumber(newScanNumber);

      if (newScanNumber.length >= 14) {
        const { gameNo, bookNo, ticketNo } = getTicketWithGameAndBook(newScanNumber);
        setGameTicketScanNo(gameNo);
        setBookTicketScanNo(bookNo);
        setTicketScanNo(ticketNo);

        const todayTicketNo = getTodayTicketNo(scannedTickets, gameNo);
        setLastTicketNo(todayTicketNo);
      }
    }
  };

  const handleInputChange = (setter) => (e) => {
    const value = e.target.value;
    if (/^\d{0,20}$/.test(value)) {
      setter(value);
    }
  };

  const clearForm = () => {
    setScanNumber("");
    setGameTicketScanNo("");
    setBookTicketScanNo("");
    setTicketScanNo("");
    setLastTicketNo(0);
  };

const handleLotteryTicketScan = async () => {
  const currentShiftId = getCurrentShiftId();

  if (!currentShiftId) {
    handleToast({ type: "ERROR", message: "No active shift found. Please select a shift first." });
    return;
  }

  if (!gameTicketScanNo || !bookTicketScanNo || !ticketScanNo) {
    handleToast({ type: "ERROR", message: "Please fill in all required fields." });
    return;
  }

  try {
    const payload = {
      activated_book_shift: currentShiftId,
      game_no: gameTicketScanNo,
      book_no: bookTicketScanNo,
      today_ticket_no: ticketScanNo,
    };
    await Post("updateGameAndInventory", payload);
    handleToast({ type: "SUCCESS", message: "Ticket scanned successfully!" });
    clearForm();
    if (onScanSuccess) {
      onScanSuccess();
    }

  } catch (error) {
    console.error("Failed to scan ticket:", error);

    const backendMessage =
      error?.response?.data?.error ||   
      error?.response?.data?.message || 
      error?.message || 
      "There was an error scanning the ticket.";

    handleToast({ type: "ERROR", message: backendMessage });
  }
};


  const handleClose = () => {
    clearForm();
    onClose();
  };

  if (!show) return null;

  const styles = {
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    },
    modal: {
      background: '#ffffff',
      borderRadius: '16px',
      width: '90%',
      maxWidth: '600px',
      maxHeight: '90vh',
      overflow: 'auto',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
      border: '1px solid #e2e8f0',
      position: 'relative',
    },
    header: {
      padding: '24px 30px',
      borderBottom: '1px solid #e2e8f0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: '#f7fafc',
      borderRadius: '16px 16px 0 0',
    },
    headerTitle: {
      margin: 0,
      fontSize: '20px',
      fontWeight: 'bold',
      color: 'black',

    },
    closeButton: {
      background: 'rgba(255, 255, 255, 0.2)',
      border: 'none',
      borderRadius: '50%',
      width: '36px',
      height: '36px',
      fontSize: '18px',
      color: 'white',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s ease',
    },
    closeButtonHover: {
      background: 'rgba(255, 255, 255, 0.3)',
      transform: 'scale(1.1)',
    },
    body: {
      padding: '30px',
      background: '#ffffff',
    },
    section: {
      marginBottom: '30px',
    },
    sectionTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#2d3748',
      marginBottom: '16px',
    },
    scanInputContainer: {
      display: 'flex',
      alignItems: 'center',
      background: '#f7fafc',
      borderRadius: '12px',
      padding: '12px 16px',
      marginBottom: '20px',
      border: '2px solid #e2e8f0',
      transition: 'all 0.3s ease',
    },
    scanInputContainerFocus: {
      border: '2px solid #667eea',

    },
    scanInput: {
      flex: 1,
      background: 'transparent',
      border: 'none',
      outline: 'none',
      fontSize: '16px',
      color: '#2d3748',
      marginLeft: '12px',
    },
    scanInputPlaceholder: {
      color: '#a0aec0',
    },
    manualInputsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
      gap: '16px',
      marginBottom: '20px',
    },
    inputGroup: {
      display: 'flex',
      flexDirection: 'column',
    },
    manualInput: {
      background: '#f7fafc',
      border: '2px solid #e2e8f0',
      borderRadius: '10px',
      padding: '12px 16px',
      fontSize: '16px',
      color: '#2d3748',
      outline: 'none',
      transition: 'all 0.3s ease',
    },
    manualInputFocus: {
      border: '2px solid #667eea',

    },
    buttonContainer: {
      display: 'flex',
      gap: '12px',
      marginTop: '20px',
    },
    scanButton: {
      background: 'green',
      color: 'white',
      border: 'none',
      borderRadius: '12px',
      padding: '14px 24px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',

      flex: 1,
    },

    countText: {
      color: '#4a5568',
      fontSize: '14px',
      fontWeight: '500',
      marginTop: '16px',
      textAlign: 'center',
      background: '#f7fafc',
      padding: '12px 16px',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
    },
    footer: {
      padding: '20px 30px',
      borderTop: '1px solid #e2e8f0',
      background: '#f7fafc',
      borderRadius: '0 0 16px 16px',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    closeFooterButton: {
      background: '#e2e8f0',
      color: '#4a5568',
      border: 'none',
      borderRadius: '10px',
      padding: '12px 24px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },

  };

  return (
    <div style={styles.modalOverlay}>
      <ToastContainer/>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h2 style={styles.headerTitle}>🎰 Lottery Ticket Scanner</h2>
          <button 
            style={styles.closeButton}
            onClick={handleClose}
            onMouseEnter={(e) => Object.assign(e.target.style, styles.closeButtonHover)}
            onMouseLeave={(e) => Object.assign(e.target.style, styles.closeButton)}
          >
            ✕
          </button>
        </div>

        <div style={styles.body}>
          {}
          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>📱 Quick Scan</h3>
            <div style={styles.scanInputContainer}>
              <LottoIcon />
              <input
                type="text"
                style={styles.scanInput}
                placeholder="Scan or enter ticket number..."
                value={scanNumber}
                onChange={handleScanNumberChange}
                onFocus={(e) => Object.assign(e.target.parentElement.style, styles.scanInputContainerFocus)}
                onBlur={(e) => Object.assign(e.target.parentElement.style, styles.scanInputContainer)}
              />
            </div>
          </div>

          {}
          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>✏️ Manual Entry</h3>
            <div style={styles.manualInputsGrid}>
              <div style={styles.inputGroup}>
                <input
                  type="text"
                  style={styles.manualInput}
                  placeholder="Game Number"
                  value={gameTicketScanNo}
                  onChange={handleInputChange(setGameTicketScanNo)}
                  onFocus={(e) => Object.assign(e.target.style, styles.manualInputFocus)}
                  onBlur={(e) => Object.assign(e.target.style, styles.manualInput)}
                />
              </div>
              <div style={styles.inputGroup}>
                <input
                  type="text"
                  style={styles.manualInput}
                  placeholder="Book Number"
                  value={bookTicketScanNo}
                  onChange={handleInputChange(setBookTicketScanNo)}
                  onFocus={(e) => Object.assign(e.target.style, styles.manualInputFocus)}
                  onBlur={(e) => Object.assign(e.target.style, styles.manualInput)}
                />
              </div>
              <div style={styles.inputGroup}>
                <input
                  type="text"
                  style={styles.manualInput}
                  placeholder="Ticket Number"
                  value={ticketScanNo}
                  onChange={handleInputChange(setTicketScanNo)}
                  onFocus={(e) => Object.assign(e.target.style, styles.manualInputFocus)}
                  onBlur={(e) => Object.assign(e.target.style, styles.manualInput)}
                />
              </div>
            </div>

            <div style={styles.buttonContainer}>
              <button 
                style={styles.scanButton}
                onClick={handleLotteryTicketScan}
                onMouseEnter={(e) => Object.assign(e.target.style, styles.scanButtonHover)}
                onMouseLeave={(e) => Object.assign(e.target.style, styles.scanButton)}
              >
                🎯 Process Ticket
              </button>
            </div>

            {/* <p style={styles.countText}>
              📊 Last Count: {lastTicketNo} tickets scanned
            </p> */}
          </div>
        </div>

        <div style={styles.footer}>
          <button 
            style={styles.closeFooterButton}
            onClick={handleClose}
            onMouseEnter={(e) => Object.assign(e.target.style, styles.closeFooterButtonHover)}
            onMouseLeave={(e) => Object.assign(e.target.style, styles.closeFooterButton)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LotteryScanModal;
